import {AnyEvent, SIGN_IN_EMAIL_SENT_EVENT} from '../type';

export default function signInEmailSent(email: string): AnyEvent {
  return {
    type: SIGN_IN_EMAIL_SENT_EVENT,
    payload: {
      email
    }
  }
}